module.exports = __webpack_public_path__ + "img/icon-avatar.af22800b.png";